import React  from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Box } from "@chakra-ui/react";

export const CarouselProvider = ({children}) => {
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1.2,
    slidesToScroll: 1,
    arrows: false
  }
  return (
      <Box
        css={{
          '.slick-track': {
            display: 'flex',
            gridGap: '10px'
          }
        }}
         w="100%"
      >
        <Slider {...settings}>
          {children}
        </Slider>
      </Box>

    );
};

